import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppMode } from "../../context/AppMode";
import AdminPasswordModal from "./AdminPasswordModal";
import { Icons } from "../../utils/icons";

export default function HomeSelector() {
  const { setMode } = useAppMode();
  const navigate = useNavigate();
  const [showAdminModal, setShowAdminModal] = useState(false);

  const selectUser = () => {
    setMode("user");
    navigate("/calendar");
  };

  const handleAdminSuccess = () => {
    setMode("admin");
    setShowAdminModal(false);
    navigate("/calendar");
  };

  return (
    <div className="home-selector container">
      <div className="home-selector-card">
        <h1>Gestion planning associatif</h1>
        <p className="subtitle">Veuillez sélectionner votre profil</p>

        <div className="home-selector-actions">
          <button className="profile-card" onClick={selectUser}>
            <div className="profile-card-title">
              <Icons.User />

              <strong>Utilisateur</strong>
            </div>
            <span>Accès planning & consultation</span>
          </button>

          <button
            className="profile-card admin"
            onClick={() => setShowAdminModal(true)}
          >
            <div className="profile-card-title">
              <Icons.Settings />
              <strong>Administrateur</strong>
            </div>
            <span>Gestion complète du panning</span>
          </button>
        </div>
      </div>

      <AdminPasswordModal
        isOpen={showAdminModal}
        onClose={() => setShowAdminModal(false)}
        onSuccess={handleAdminSuccess}
      />
    </div>
  );
}
